<template>
    <div class="col-md-6">
        <div class="panel panel-default">
            <div class="panel-heading">
                {{trans_heading}}
            </div>
            <div class="panel-body">
                <plot :id="plotId" :ref="plotId" :options="options" :type="type"></plot>
            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import Plot from './Plot';

  export default {
    components: {'Plot': Plot},
    data() {
      return {
        trans_heading: Worklog.workTimeYearMonthCompare.trans_heading,
        trans_total  : Worklog.workTimeYearMonthCompare.trans_total,
        url          : Worklog.workTimeYearMonthCompare.url,
        plotId       : 'workTimeYearMonthCompareChart',
        type         : 'line',
        options      : {
          elements: {
            line: {
              tension: 0.000001
            }
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          hover: {
            mode: 'nearest',
            intersect: true
          },
          legend: {
            position: 'top',
          },
        },
      }
    },
    watch     : {
      selectedMonth: function (val) {
        this.fetchData();
      },
    },
    mounted() {
      this.$refs[ this.plotId ].updateChart(Worklog.workTimeYearMonthCompare.data);
    },
    methods   : {
      fetchData() {
        axios.get(this.url.replace(':month', this.selectedMonth))
          .then(response => {
            response.data && this.$refs[ this.plotId ].updateChart(response.data);
          })
          .catch(e => {
            this.$refs[ this.plotId ].updateChart({
              dataSets: [],
              labels  : []
            });
          })
      }
    }
  }
</script>
